var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_15581)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 4.625C3.75 4.19312 4.1444 3.75 4.75 3.75H15.25C15.8556 3.75 16.25 4.19312 16.25 4.625V6.25H7H6.25V7V15.25H4.75C4.1444 15.25 3.75 14.8069 3.75 14.375V4.625ZM7.75 15.25H11V12.5H7.75V15.25ZM7.75 11H11V7.75H7.75V11ZM12.5 7.75V11H16.25V7.75H12.5ZM16.25 12.5H12.5V15.25H15C15.6904 15.25 16.25 14.6904 16.25 14V12.5ZM6.25 16.75H4.75C3.4226 16.75 2.25 15.738 2.25 14.375V4.625C2.25 3.26195 3.4226 2.25 4.75 2.25H15.25C16.5774 2.25 17.75 3.26195 17.75 4.625V6.25V7V14V14.375C17.75 15.738 16.5774 16.75 15.25 16.75H15H7H6.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_15581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaders);
export default __webpack_public_path__ + "static/media/headers.b36551f4641279d5a9fc11fb178650f0.svg";
export { ForwardRef as ReactComponent };